import {
  SET_CURRENT_MODULE_ITEM,
  SET_MODULE_ITEMS_FILTER_BY_NAME,
  SET_MODULE_ITEMS_FILTER_BY_CATEGORY,
  BASE_MODULE_ITEMS_LIST_REQUEST,
  BASE_MODULE_ITEMS_LIST_SUCCESS,
  BASE_MODULE_ITEMS_LIST_FAILURE,
  CLEAR_FORM_MEDIA_FILED,
  BASE_MODULE_ITEM_SAVE_REQUEST,
  BASE_MODULE_ITEM_SAVE_SUCCESS,
  BASE_MODULE_ITEM_SAVE_FAILURE,
  BASE_MODULE_ITEM_NSI_TYPES_SUCCESS,
  NSI_DETAIL_FILTERS_SUCCESS,
  BASE_MODULE_ITEM_DELETE_REQUEST,
  BASE_MODULE_ITEM_DELETE_SUCCESS,
  BASE_MODULE_ITEM_DELETE_FAILURE,
} from './../actions/baseModuleItems';
import { CLOSE_MEDIA_MANAGER } from './../actions/mediaManager';

const initialState = {
  currentItem: null,
  itemsList: [],
  fetchingItemsList: false,
  fetchItemSave: false,
  fetchItemDelete: false,
  filterByName: '',
  filterByCategory: null,
  currentFormMediaField: null,
  customProductTypes: [],
  customDetailFilters: [],
};

const baseModuleItems = (state = initialState, action) => {
  switch (action.type) {
    case BASE_MODULE_ITEM_SAVE_REQUEST: {
      return {
        ...state,
        fetchItemSave: true,
      };
    }
    case BASE_MODULE_ITEM_SAVE_SUCCESS: {
      return {
        ...state,
        fetchItemSave: false,
      };
    }
    case BASE_MODULE_ITEM_SAVE_FAILURE: {
      return {
        ...state,
        fetchItemSave: false,
      };
    }
    case BASE_MODULE_ITEM_DELETE_REQUEST: {
      return {
        ...state,
        fetchItemDelete: true,
      };
    }
    case BASE_MODULE_ITEM_DELETE_SUCCESS: {
      return {
        ...state,
        fetchItemDelete: false,
      };
    }
    case BASE_MODULE_ITEM_DELETE_FAILURE: {
      return {
        ...state,
        fetchItemDelete: false,
      };
    }
    case SET_CURRENT_MODULE_ITEM:
      return {
        ...state,
        currentItem: action.payload,
      };
    case SET_MODULE_ITEMS_FILTER_BY_NAME:
      return {
        ...state,
        filterByName: action.payload,
      };
    case SET_MODULE_ITEMS_FILTER_BY_CATEGORY:
      return {
        ...state,
        filterByCategory: action.payload,
      };
    case BASE_MODULE_ITEM_NSI_TYPES_SUCCESS:
      return {
        ...state,
        customProductTypes: action.response,
      };
    case NSI_DETAIL_FILTERS_SUCCESS:
      return {
        ...state,
        customDetailFilters: action.response,
      };
    case BASE_MODULE_ITEMS_LIST_REQUEST:
      return {
        ...state,
        fetchingItemsList: true,
      };
    case BASE_MODULE_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        fetchingItemsList: false,
        itemsList: action.response,
      };
    case BASE_MODULE_ITEMS_LIST_FAILURE:
      return {
        ...state,
        fetchingItemsList: false,
        itemsList: initialState.itemsList,
      };
    case CLOSE_MEDIA_MANAGER:
      if (state.currentFormMediaField && action.value) {
        return {
          ...state,
          currentFormMediaField: {
            ...state.currentFormMediaField,
            media: action.value,
          },
        };
      }
      return state;
    case CLEAR_FORM_MEDIA_FILED:
      return {
        ...state,
        currentFormMediaField: null,
      };
    default:
      return state;
  }
};

export { baseModuleItems as default };



// WEBPACK FOOTER //
// ./src/reducers/baseModuleItems.js